import { useNavigate } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import React, { useEffect, useState, useContext, useRef } from "react";
import axios from "axios";
import { CartContext } from "../../../contexts/cartContext";
import { CurrencyContext } from "../../../contexts/currencyContext"; // Import context
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import RequestModal from "../components/RequestModal";
import LoaderHomePd from "../components/loaderHomePd";
import {sendSubscriptionRequestEmail} from "../../utility/emailUtility";

const Home = () => {

    const { currencyContxt } = useContext(CurrencyContext); // Use context

    const [wishlists, setWishlists] = useState([]);
    const { wishlist, addToWishlist } = useContext(CartContext);

    const [newarrivalsArts, setNewarrivalsArts] = useState([]);
    const [eliteChoiceArts, setEliteChoiceArts] = useState([]);
    const [affordableArts, setAffordableArts] = useState([]);
    const [discountedArts, setDiscountedArts] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedPd, setSelectedPd] = useState(null);

    const handleRequestPrice = (id, pdTitle) => {
        setModalOpen(true);
        setSelectedId(id);
        setSelectedPd(pdTitle);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedId(null);
        setSelectedPd(null);
    };

    const emailRef = useRef(null);
    const [email, setEmail] = useState("");
    const [isValidEmail, setIsValidEmail] = useState(true);

    const navigate = useNavigate();
    const ArtDetails = () => {
        navigate(`/artwork`);
    };
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    let slider1 = [];
    let slider2 = [];

    const [featuredArtist, setFeaturedArtist] = useState([]);
    const getFeaturedArtist = async () => {
        try {
            const response = await axios.get('https://igapi.heuristticminds.com/api/UserInterface/Get-GetFeaturedArtistList')
            setFeaturedArtist(response.data);
        } catch (error) {
            console.log(error);
        }
    }
    useEffect(() => {
        getFeaturedArtist();
    }, []);

    // Change by Ranjan on 08 Nov 2024 ro routing
    const categoryMapping = {
        72: "painting",
        73: "drawing",
        74: "printmaking",
        103: "tapestry",
        134: "sculpture",
        1: "New-arrivals",
        2: "Elite-choice",
        3: "Affordable",
        4: "discounted",
    };

    const ArtCategory = (e) => {

        // Get the category name based on the categoryId
        const categoryName = categoryMapping[e.categoryId];
    
        if (categoryName) {
            // Use navigate with categoryName instead of categoryId
            navigate(`/artworks/${categoryName}`, { state: { categoryId: e.categoryId, subCategoryId: e.subCategoryId, typeId: e.typeId}});
            window.scrollTo({
                top: 0,
                behavior: "instant"
            });
            } else {
                console.error("Invalid categoryId");
            }
    };

    const HandleViewAll = (artworkType) => {
        debugger;
        // Get the category name based on the artworkType
        const artworkCategory = categoryMapping[artworkType];

        navigate(`/artwork-all/${artworkCategory}`, { state: { artworkType: artworkType}});
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    };
    const handleArtist = (artistId, artistName) => {
        const artist = artistName.replace(/ /g, '-'); // Replace spaces with '-'
        navigate(`/artist/${artist}-${artistId}`, { state: { artistId: artistId}});
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    };


    const handleDetails = (id, productTitle) => {
        const formattedTitle = productTitle.replace(/ /g, '-'); // Replace spaces with '-'
        navigate(`/artwork/${formattedTitle}-${id}`, { state: { id: id}});
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    };

    const getNewarrivalsArts = async () => {
        try {
            setLoading(true);
            const delay = new Promise(resolve => setTimeout(resolve, 500)); // 500 ms delay
            await delay;

            const response = await axios.get('https://igapi.heuristticminds.com/api/UserInterface/Get-GetArtworkNewArrival');
            // Check if the response is valid
            if (Array.isArray(response.data)) {
                setNewarrivalsArts(response.data);
            } else {
                setError('Unexpected data format');
            }
        } catch (error) {
            setError('Failed to fetch data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        getNewarrivalsArts();
    }, []);

    const GetArtworkEliteChoice = async () => {
        try {
            setLoading(true);
            const delay = new Promise(resolve => setTimeout(resolve, 500)); // 500 ms delay
            await delay;

            const response = await axios.get('https://igapi.heuristticminds.com/api/UserInterface/Get-GetArtworkEliteChoice')
            setEliteChoiceArts(response.data);
        }
        catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        GetArtworkEliteChoice();
    }, []);

    const GetArtworkAffordableArt = async () => {
        try {
            setLoading(true);
            const delay = new Promise(resolve => setTimeout(resolve, 500)); // 500 ms delay
            await delay;

            const response = await axios.get('https://igapi.heuristticminds.com/api/UserInterface/Get-GetArtworkAffordableArt')
            setAffordableArts(response.data);
        }
        catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        GetArtworkAffordableArt();
    }, []);

    const GetArtworkDiscountedArt = async () => {
        try {
            setLoading(true);
            const delay = new Promise(resolve => setTimeout(resolve, 500)); // 500 ms delay
            await delay;

            const response = await axios.get('https://igapi.heuristticminds.com/api/UserInterface/Get-GetArtworkDiscountedArt')
            setDiscountedArts(response.data);
        }
        catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        GetArtworkDiscountedArt();
    }, []);

    const SliderBannerLeft = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        arrows: false
    };
    const SliderBannerRight = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        arrows: false
    };

    //const selectedCurrency = JSON.parse(localStorage.getItem('selectedCurrency'));
    useEffect(() => {
        setNav1(slider1);
        setNav2(slider2);
    },);
    //}, [selectedCurrency]);

    //Wishlist Click
    const userInfo = JSON.parse(localStorage.getItem('user-info'));
    // Fetch the wishlist data when the page loads
    const fetchWishlistData = async () => {
                
        if (userInfo && userInfo.buyer_id) {
            try {
                const response = await fetch(`https://igapi.heuristticminds.com/api/WishList/Get-GetWishListByUserID?user_id=${userInfo.buyer_id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const wishlistData = await response.json();

                setWishlists(wishlistData && Array.isArray(wishlistData) ? wishlistData : []);

            } catch (error) {
                console.error('Error fetching wishlist:', error);
            }
        } else {
            const localWishlist = getWishlistFromLocalStorage();
            setWishlists(localWishlist); // Store complete wishlist items from local storage
        }
    };

    
    // Helper function to get wishlist from localStorage
    const getWishlistFromLocalStorage = () => {
        return JSON.parse(localStorage.getItem('wishlist')) || [];
    };

    // Check if the item is in the wishlist
    const isInWishlist = (productId) => {
        return wishlists.some(item => item.product_id === productId);
    };

    // Handler for Wishlist Button Click
    const handleWishlistClick = async(item) => {

        const itemIsInWishlist = isInWishlist(item.product_id);

        if (userInfo && userInfo.buyer_id) {

            try {
                const payload = {
                    customer_id: userInfo.buyer_id,
                    product_id: item.product_id,
                };
                const response = await fetch("https://igapi.heuristticminds.com/api/WishList/Add-SaveWishList", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });
                    // Check if the response was successful
            if (!response.ok) {
                throw new Error(`Failed to update wishlist: ${response.statusText}`);
            }

            // Extract JSON data from the response
            const { action } = await response.json(); // Destructuring to get action flag


            // Display success message based on the action performed
            if (action === "Add") {
                toast.success("Artwork Added to Wishlist !!");
            } else if (action === "Remove") {
                toast.error("Artwork Removed from Wishlist !!");
            }
                    // Fetch the updated wishlist after modification
                    await fetchWishlistData();  // Refresh state with the updated wishlist from the database
            } catch (error) {
                console.error("Error syncing wishlist item:", item.product_id, error);
            }
        }
        else{
            if (itemIsInWishlist) {
                // Remove from wishlist logic
                removeFromWishlist(item.product_id);
                toast.error("Artwork Removed from Wishlist !!");
            } else {
                addToWishlist(item);
                toast.success("Artwork Added to Wishlist !!");
            }
        }
        

        handleWishlistUpdate(); // Refresh wishlist state after adding/removing
    };
    
    // Function to remove item from the wishlist
    const removeFromWishlist = (productId) => {
        const updatedWishlist = wishlists.filter(item => item.product_id !== productId);
        setWishlists(updatedWishlist); // Update state
        localStorage.setItem('wishlist', JSON.stringify(updatedWishlist)); // Update local storage
    };

    // Context or state management function
    const handleWishlistUpdate = () => {
        
        if (userInfo && userInfo.buyer_id) {
            fetchWishlistData(); // Fetch from API
        } else {
            const updatedWishlist = getWishlistFromLocalStorage(); // Fetch from local storage
            setWishlists(updatedWishlist); // Update state
        }        
    };



    useEffect(() => {
        fetchWishlistData(); // Fetch wishlist data when component mounts
    }, []);
    
    useEffect(() => {
        setWishlists(wishlist);
    }, [wishlist]); // This will trigger every time the wishlist state changes


    //WishList Click ends

    // Subscribe Click Start here

    const handleEmailChange = async (event) => {
        const inputEmail = event.target.value;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setEmail(inputEmail);
        setIsValidEmail(emailRegex.test(inputEmail) || inputEmail === "");

        // Check for duplicate email
        //await checkForDuplicates(mobile, inputEmail);
    };
    const handleSubscribe = async (event) => {
        event.preventDefault();

        if (email.trim() === '') {
            alert("Please enter a valid email address.");
            emailRef.current.focus();
            return;
        }
        if (!isValidEmail) {
            alert('Please enter a valid email address.');
            emailRef.current.focus();
            return;
        }
        const formData = {
            email,
        };

        try {
            const response = await fetch('https://igapi.heuristticminds.com/api/MailerList/Add-SaveSubscriberEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {

                // Proceed to send email
                const success = await sendSubscriptionRequestEmail(email.trim());
                if (success) {
                    toast.success("Thank you for subscribing to IndiGalleria !!");
                } else {
                   
                }
                setEmail("");
                setIsValidEmail(true);
                

            } else {
                console.error('Error saving form data:', response.statusText);
            }
        } catch (error) {
            console.error('Error saving form data:', error);
        }
    }

    // Subscribe Ends Here

    return (
        <>
            <Header />

            <div className="main_bg" style={{ marginTop: '110px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 overflow-hidden">

                            <div className="slider-heading">
                                <Slider {...SliderBannerLeft}>
                                    <div>
                                        <h1 className="title">
                                            Connecting Art and Art Admirers around the World
                                        </h1>
                                        <p className="subtitle">
                                            We ship original paintings worldwide!
                                        </p>
                                    </div>
                                    <div>
                                        <h1 className="title">
                                            Best Price on Original Artwork and Painting
                                        </h1>
                                        <p className="subtitle">
                                            Be the first to know about the new arrival curated collections, original paintings &
                                            artwork and exclusive sales
                                        </p>
                                    </div>
                                    <div>
                                        <h1 className="title">
                                            Go for Original Paintings online
                                        </h1>
                                        <p className="subtitle">
                                            We are offering high-quality original artworks and paintings of well-known artists of
                                            India at very affordable prices.
                                        </p>
                                    </div>
                                </Slider>

                            </div>
                            <a href="#" className="btn_search">Shop Now <i className="bi bi-arrow-right"></i></a>
                        </div>
                        <div className="col-md-6 p-4 overflow-hidden">
                            <figure>
                                <div className="outerBevel">
                                    <div className="flatSurface">
                                        <div className="innerBevel">
                                            <div className="banner_frame">
                                                <Slider {...SliderBannerRight}>
                                                    <div className="item">
                                                        <img src="images/banner-1.jpg" alt="" className="w-100" />
                                                    </div>
                                                    <div className="item">
                                                        <img src="images/banner-2.jpg" alt="" className="w-100" />
                                                    </div>
                                                    <div className="item">
                                                        <img src="images/banner-3.jpg" alt="" className="w-100" />
                                                    </div>
                                                </Slider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </figure>
                        </div>
                    </div>
                </div>
                <div className="banner_shape" data-negative="false">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none">
                        <path className="shape_fill" d="M0,6V0h1000v100L0,6z"></path>
                    </svg>
                </div>
            </div>

            <div className="welcome_sec">
                <div className="text-center">
                    <div className="welcome_title">
                        <h2>Welcome to <span>IndiGalleria</span></h2>
                        <p>Original Handmade Paintings & Artworks from India</p>
                    </div>
                </div>

                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="category bg1" onClick={(e) => ArtCategory({ categoryId: 72, subCategoryId: 0, typeId: 0 })}>
                                <div className="category_title">
                                    <div className="category_icon i1">
                                        <i></i>
                                    </div>
                                    <h2>Painting</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="category bg2" onClick={(e) => ArtCategory({ categoryId: 73, subCategoryId: 0, typeId: 0 })}>
                                <div className="category_title">
                                    <div className="category_icon i2">
                                        <i></i>
                                    </div>
                                    <h2>Drawing</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="category bg3" onClick={(e) => ArtCategory({ categoryId: 74, subCategoryId: 0, typeId: 0 })}>
                                <div className="category_title">
                                    <div className="category_icon i3">
                                        <i></i>
                                    </div>
                                    <h2>Printmaking</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="category bg4" onClick={(e) => ArtCategory({ categoryId: 103, subCategoryId: 0, typeId: 0 })}>
                                <div className="category_title">
                                    <div className="category_icon i4">
                                        <i></i>
                                    </div>
                                    <h2>Tapestry</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="category bg5" onClick={(e) => ArtCategory({ categoryId: 134, subCategoryId: 0, typeId: 0 })}>
                                <div className="category_title">
                                    <div className="category_icon i5">
                                        <i></i>
                                    </div>
                                    <h2>Sculpture</h2>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

                <div className="container d-none">
                    <div className="row">
                        <div className="col">
                            <div className="category bg1">
                                <div className="category_title">
                                    <div className="category_icon i1">
                                        <i></i>
                                    </div>
                                    <h2>Painting</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="category bg2">
                                <div className="category_title">
                                    <div className="category_icon i2">
                                        <i></i>
                                    </div>
                                    <h2>Drawing</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="category bg3">
                                <div className="category_title">
                                    <div className="category_icon i3">
                                        <i></i>
                                    </div>
                                    <h2>Printmaking</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="category bg4">
                                <div className="category_title">
                                    <div className="category_icon i4">
                                        <i></i>
                                    </div>
                                    <h2>Tapestry</h2>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="category bg5">
                                <div className="category_title">
                                    <div className="category_icon i5">
                                        <i></i>
                                    </div>
                                    <h2>Sculpture</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mt-5">
                            <div className="d-flex justify-content-between">
                                <h2 className="sec_title">NEW ARRIVALS</h2>
                                <button className="btn_viewall" onClick={(e) => HandleViewAll(1)}>View All</button>
                            </div>
                            <p>Creativity never ceases to exist. Our motivated team of talented artists, inspired by the incessant beauty offered by nature or their surroundings are always up with something exotic and unique that not only adds to their own collection of artworks but also to the walls of our gallery. We are always enthralled to see their new collection as it always has something extra to add to our limited array of thoughts. We wish the same shopping experience to you as well, hence do check out the latest collection of artworks and grab the original piece that you connect and share your ideas with, before someone else does. </p>
                        </div>
                        <div className="col-md-12 p-2">
                            {loading && <LoaderHomePd />}
                            <div className="results">
                                {
                                    newarrivalsArts.map(newarrival => (
                                        <div className="pd_item" key={newarrival?.product_id}>
                                            <div className="img_box">
                                                <img src={`../../../images/products/thumbnail/${newarrival?.image}`} className="pd_img" alt="" />
                                                <a href="#" className="wishlist_link" title="WISHLIST"
                                                    onClick={() => handleWishlistClick(newarrival)}>
                                                    <i className={`${isInWishlist(newarrival?.product_id) ? 'bi bi-suit-heart-fill text-danger' : 'bi bi-suit-heart'}`}></i>
                                                </a>
                                                <span className="q_view" onClick={() => handleDetails(newarrival?.product_id,  newarrival?.productTitle)}><i className="bi bi-eye"></i> Quick View</span>
                                                <span className="size">Size: <b>{newarrival?.size}</b></span>
                                            </div>
                                            <div className="pd_content">
                                                <span className="pd_brand">{newarrival?.productTitle}</span>
                                                <span className="pd_title">{newarrival?.category}: {newarrival?.categoryType}</span>
                                                <span className="pd_title">Art by: <span className="btn_artist1">{newarrival?.artistName}</span></span>
                                                {
                                                    newarrival?.price_on_demand === 1 ? <><span className="btn_req" onClick={() => handleRequestPrice(newarrival?.product_id, newarrival?.productTitle)}>Request Price</span></> :

                                                        <div className="Price">
                                                            {currencyContxt.icon} {(newarrival?.price / currencyContxt.value).toFixed(2)}
                                                            {
                                                                newarrival?.discountRate === 0 ? ''
                                                                    : <>
                                                                        <span className="old_price">{currencyContxt.icon} {(newarrival?.gstMRP / currencyContxt.value).toFixed(2)}</span><span className="discount">({newarrival?.discountRate}%)</span>
                                                                    </>
                                                            }
                                                            {
                                                                currencyContxt.currency == "INR" ?
                                                                    <small>Including GST</small>
                                                                    :
                                                                    <></>
                                                            }
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pd_sec" style={{ backgroundColor: '#f6f6f6' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mt-5">
                            <div className="d-flex justify-content-between">
                                <h2 className="sec_title">GALLERY CURATOR'S CHOICE</h2>
                                <button className="btn_viewall" onClick={(e) => HandleViewAll(2)}>View All</button>
                            </div>
                            <p>There are artworks that we do not distinguish based on prices, as the name might tacitly suggest to you. It is the quality of the piece, the level of creativity by the artist, and the thoughts that went behind the making of this artwork, henceforth, it is what we call the 'Elite's Choice', and it is the best-sorted piece here. People with a genuine interest and an eye for details would fall in love with this section, and it would be no surprise for us if they end up buying more artwork than they actually planned. This section holds all those artworks that would definitely add more influence to your already existing collection of artworks, and convey an accumulation to your notable and intrinsic quality of choosing artworks. Hence, do what your stature of taste in artwork deserves, browse and consolidate all those pieces of art that go well with you!</p>
                        </div>
                        <div className="col-md-12 p-2">
                            {loading && <LoaderHomePd />}
                            <div className="results">
                                {
                                    eliteChoiceArts.map(eliteChoice => (
                                        <div className="pd_item" key={eliteChoice?.product_id}>
                                            <div className="img_box">
                                                <img src={`../../../images/products/thumbnail/${eliteChoice?.image}`} className="pd_img" alt="" />
                                                <a href="#" className="wishlist_link" title="WISHLIST"
                                                    onClick={() => handleWishlistClick(eliteChoice)}>
                                                    <i className={`${isInWishlist(eliteChoice?.product_id) ? 'bi bi-suit-heart-fill text-danger' : 'bi bi-suit-heart'}`}></i>
                                                </a>
                                                <span className="q_view" onClick={() => handleDetails(eliteChoice?.product_id, eliteChoice?.productTitle)}><i className="bi bi-eye"></i> Quick View</span>
                                                <span className="size">Size: <b>{eliteChoice?.size}</b></span>
                                            </div>
                                            <div className="pd_content">
                                                <span className="pd_brand">{eliteChoice?.productTitle}</span>
                                                <span className="pd_title">{eliteChoice?.category}: {eliteChoice?.categoryType}</span>
                                                <span className="pd_title">Art by: <span className="btn_artist1">{eliteChoice?.artistName}</span></span>
                                                {
                                                    eliteChoice?.price_on_demand === 1 ? <><span className="btn_req" onClick={() => handleRequestPrice(eliteChoice?.product_id, eliteChoice?.productTitle)}>Request Price</span></> :

                                                        <div className="Price">
                                                            {currencyContxt.icon} {(eliteChoice?.price / currencyContxt.value).toFixed(2)}
                                                            {
                                                                eliteChoice?.discountRate === 0 ? ''
                                                                    : <>
                                                                        <span className="old_price">{currencyContxt.icon} {(eliteChoice?.gstMRP / currencyContxt.value).toFixed(2)}</span><span className="discount">({eliteChoice?.discountRate}%)</span>
                                                                    </>
                                                            }
                                                            {
                                                                currencyContxt.currency == "INR" ?
                                                                    <small>Including GST</small>
                                                                    :
                                                                    <></>
                                                            }
                                                        </div>
                                                }

                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pd_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mt-5">
                            <div className="d-flex justify-content-between">
                                <h2 className="sec_title">AFFORDABLE ARTWORKS</h2>
                                <button className="btn_viewall" onClick={(e) => HandleViewAll(3)}>View All</button>
                            </div>
                            <p>We also care for our budget clients who want to buy original paintings for home décor or any other purpose. In this section, we have kept good artwork by budding and upcoming artists including experienced artists. You may contact us with your budget and taste, we have several artworks which are not listed here.</p>
                        </div>
                        <div className="col-md-12 p-2">
                            {loading && <LoaderHomePd />}
                            <div className="results">
                                {
                                    affordableArts.map(affordableArt => (
                                        <div className="pd_item" key={affordableArt?.product_id}>
                                            <div className="img_box">
                                                <img src={`../../../images/products/thumbnail/${affordableArt?.image}`} className="pd_img" alt="" />
                                                <a href="#" className="wishlist_link" title="WISHLIST"
                                                    onClick={() => handleWishlistClick(affordableArt)}>
                                                    <i className={`${isInWishlist(affordableArt?.product_id) ? 'bi bi-suit-heart-fill text-danger' : 'bi bi-suit-heart'}`}></i>
                                                </a>
                                                <span className="q_view" onClick={() => handleDetails(affordableArt?.product_id, affordableArt?.productTitle)}><i className="bi bi-eye"></i> Quick View</span>
                                                <span className="size">Size: <b>{affordableArt?.size}</b></span>
                                            </div>
                                            <div className="pd_content">
                                                <span className="pd_brand">{affordableArt?.productTitle}</span>
                                                <span className="pd_title">{affordableArt?.category}: {affordableArt?.categoryType}</span>
                                                <span className="pd_title">Art by: <span className="btn_artist1">{affordableArt?.artistName}</span></span>
                                                {
                                                    affordableArt?.price_on_demand === 1 ? <><span className="btn_req" onClick={() => handleRequestPrice(affordableArt?.product_id, affordableArt?.productTitle)}>Request Price</span></> :

                                                        <div className="Price">
                                                            {currencyContxt.icon} {(affordableArt?.price / currencyContxt.value).toFixed(2)}
                                                            {
                                                                affordableArt?.discountRate === 0 ? ''
                                                                    : <>
                                                                        <span className="old_price">{currencyContxt.icon} {(affordableArt?.gstMRP / currencyContxt.value).toFixed(2)}</span><span className="discount">({affordableArt?.discountRate}%)</span>
                                                                    </>
                                                            }
                                                            {
                                                                currencyContxt.currency == "INR" ?
                                                                    <small>Including GST</small>
                                                                    :
                                                                    <></>
                                                            }
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pd_sec" style={{ backgroundColor: '#f6f6f6' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mt-5">
                            <div className="d-flex justify-content-between">
                                <h2 className="sec_title">DISCOUNTED ARTWORKS</h2>
                                <button className="btn_viewall" onClick={(e) => HandleViewAll(4)}>View All</button>
                            </div>
                            <p>On our platform, we cater to every person within whom creativity exists, who would admire and cherish the art masterpieces created by the artists. There are those artworks that were meant to tell a story to anyone who would see it. Its colours and vibrancy are such that. We have made those artworks more affordable to you by offering limited-period discounts on them, lucky are you to have witnessed them now and smarter it would be to not let go of that opportunity! So adorn your walls with the most exotic pieces and let the magic of colors begin!</p>
                        </div>
                        <div className="col-md-12 p-2">
                            {loading && <LoaderHomePd />}
                            <div className="results">
                                {
                                    discountedArts.map(discountedArt => (
                                        <div className="pd_item" key={discountedArt?.product_id}>
                                            <div className="img_box">
                                                <img src={`../../../images/products/thumbnail/${discountedArt?.image}`} className="pd_img" alt="" />
                                                <a href="#" className="wishlist_link" title="WISHLIST"
                                                    onClick={() => handleWishlistClick(discountedArt)}>
                                                    <i className={`${isInWishlist(discountedArt?.product_id) ? 'bi bi-suit-heart-fill text-danger' : 'bi bi-suit-heart'}`}></i>
                                                </a>
                                                <span className="q_view" onClick={() => handleDetails(discountedArt?.product_id, discountedArt?.productTitle)}><i className="bi bi-eye"></i> Quick View</span>
                                                <span className="size">Size: <b>{discountedArt?.size}</b></span>
                                            </div>
                                            <div className="pd_content">
                                                <span className="pd_brand">{discountedArt?.productTitle}</span>
                                                <span className="pd_title">{discountedArt?.category}: {discountedArt?.categoryType}</span>
                                                <span className="pd_title">Art by: <span className="btn_artist1">{discountedArt?.artistName}</span></span>
                                                {
                                                    discountedArt?.price_on_demand === 1 ? <><span className="btn_req" onClick={() => handleRequestPrice(discountedArt?.product_id, discountedArt?.productTitle)}>Request Price</span></> :

                                                        <div className="Price">
                                                            {currencyContxt.icon} {(discountedArt?.price / currencyContxt.value).toFixed(2)}
                                                            {
                                                                discountedArt?.discountRate === 0 ? ''
                                                                    : <>
                                                                        <span className="old_price">{currencyContxt.icon} {(discountedArt?.gstMRP/ currencyContxt.value).toFixed(2)}</span><span className="discount">({discountedArt?.discountRate}%)</span>
                                                                    </>
                                                            }
                                                            {
                                                                currencyContxt.currency == "INR" ?
                                                                    <small>Including GST</small>
                                                                    :
                                                                    <></>
                                                            }
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="abt_sec">
                <div className="container">
                    <div className="row">
                        <div className="col-md-9 text-center  m-auto">
                            <h2 className="sec_title">About Us</h2>
                            <p className="">So if you are here, you are definitely looking for the best collection of original paintings and artwork available at the best price. IndiGalleria is one of the best Online Art Gallery platforms in India that caters to both artists and art lovers alike. It supports artists to exhibit & sell their work to a far broader audience and equally provides art lovers an opportunity to purchase original masterpieces in a few defined steps.</p>
                            <p className="abt_subtitle">
                                Follow us on all your favourite social media sites!
                            </p>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="wrapper m-auto">
                                <div className="tbicon_wrap">
                                    <div className="tb_icon" id="tb-youtube">
                                        <i className="bi bi-youtube"></i>
                                    </div>
                                    <div className="tb_icon" id="tb-facebook">
                                        <i className="bi bi-facebook"></i>
                                    </div>
                                    <div className="tb_icon" id="tb-instagram">
                                        <i className="bi bi-instagram"></i>
                                    </div>
                                    <div className="tb_icon" id="tb-pinterest">
                                        <i className="bi bi-pinterest"></i>
                                    </div>
                                    <div className="tabicon">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="testimonial_sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-5 pe-5">
                                <h2 className="sec_title">Our Featured Artists</h2>
                                <p style={{ textAlign: 'justify' }}>
                                    They say you cannot use up creativity, the more you use
                                    the more you
                                    have. It does not wait for that perfect moment. Our team of artists aptly fits into this
                                    definition. Their creativity can have fun with colours to blow your mind away when the
                                    masterpiece is out. Their way of creating artwork involves breaking the old set patterns and
                                    creating things from a different perspective altogether. Their inspiration can come from
                                    anything because for them creativity is not defined by objects and have no boundaries. We
                                    take immense pride in displaying their outstanding artworks and presenting them to the
                                    audience. Do have a look at your favorite artwork and get to know more about the story of
                                    the artist!
                                </p>

                            </div>
                            <div className="col-xl-7 ps-5">
                                <div className="test_box mt-4 text-center">
                                    <Slider
                                        asNavFor={nav1}
                                        ref={slider => (slider2 = slider)}
                                        slidesToShow={3}
                                        swipeToSlide={true}
                                        focusOnSelect={true}
                                        infinite={true}
                                        className="thumb"
                                        arrows={false}
                                        centerMode={true}
                                    >
                                        {featuredArtist.map(ImageUrl => (
                                            <div className="test_img" key={ImageUrl.artist_id}>
                                                <img src={`../../images/artist/${ImageUrl.image}`} />
                                            </div>
                                        ))}

                                    </Slider>
                                    <Slider
                                        asNavFor={nav2}
                                        ref={slider => (slider1 = slider)}
                                        autoplay={true}
                                        arrows={false}
                                        className="imgShow"
                                    >
                                        {featuredArtist.map(ftrArtist => (
                                            <div className="test_content" key={ftrArtist.artist_id}>
                                                <h6 className="btn_artist2" onClick={() => handleArtist(ftrArtist.artist_id, ftrArtist.artistName)}>{ftrArtist.artistName}</h6>
                                                <span className="d-block">{ftrArtist.city}</span>
                                                <p>
                                                    {ftrArtist.artistDetails} 
                                                </p>
                                            </div>
                                        ))}

                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="getintouch">
                <div className="container">
                    <div className="getintouch-wrap">
                        <div className="row d-flex align-items-center justify-content-end">
                            <div className="col-md-6">
                                <h5 className="title">Sign Up for our Newsletter</h5>
                                <p className="subtitle">For updates on Exhibitions, Events, Promotions and More!</p>
                                <div className="subscribe-wrap">
                                    <input type="text"
                                        value={email}
                                        onInput={handleEmailChange}
                                        id="email"
                                        ref={emailRef}
                                        maxLength={45}
                                        placeholder="Enter your email address"
                                        className={` txt1 form-control ${isValidEmail ? "" : "is-invalid"}`}
                                        autoComplete="off"
                                    />
                                    {!isValidEmail && (
                                        <div className="invalid-feedback">Please enter a valid email address.</div>
                                    )}
                                    <button type="submit"
                                        onClick={handleSubscribe}
                                    >Subscribe</button>
                                </div>
                                <p className="para">By subscribing or registering you are agreeing to the IndiGalleria's <a href="/privacyPolicy">Privacy Policy</a><br /> and <a href="/termsConditions">Terms of Service</a></p>
                            </div>
                            <div className="col-md-6 text-center">
                                <div className="getintouch-img">

                                    <img src="../images/icon-email.svg" />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer position="bottom-right" />
            <RequestModal isOpen={isModalOpen} onClose={handleCloseModal} id={selectedId} pdTitle={selectedPd} />
            <Footer />
        </>
    )
};

export default Home;